import React from "react";
import MultipleSelectDropdown from "../MultipleSelectDropdown";

/**
 * PBI #300: lets the orderer pick add-on licences for the user from the customer's own
 * licence portfolio. The options arrive de-duplicated per product from the API, so one
 * product is offered once however many billing-group rows it is split over.
 *
 * A customer with no add-on licences gets no picker at all rather than an empty dropdown.
 */
const AddOnLicensePicker = ({ options = [], selected = [], onChange = () => {} }) => {
  const licenses = Array.isArray(options) ? options : [];
  if (licenses.length === 0) return null;

  return (
    <div className="flex flex-col w-full">
      <MultipleSelectDropdown
        label="Add-on licenses"
        options={licenses.map((license) => ({
          label: license.name,
          value: license.licensePublicId,
        }))}
        selected={Array.isArray(selected) ? selected : []}
        onChange={onChange}
        placeholder="Choose add-on licenses"
      />
    </div>
  );
};

export default AddOnLicensePicker;
